// First Created - 08 Oct 2026
// Author - Atul Pandey
// Purpose - Update Session Reference Content

import React from "react"

import {
    useNavigate,
} from "react-router"

import useTitle from "@/hooks/useTitle"

import PulseLoader
    from "react-spinners/PulseLoader"

import {
    useGetSessionReferenceContentByIdQuery,
    useUpdateSessionReferenceContentMutation,
} from "./sessionReferenceContentApiSlice"

import EtSessionReferenceContentForm
    from "./EtSessionReferenceContentForm"


/*
|--------------------------------------------------------------------------
| 01 - Main Component
|--------------------------------------------------------------------------
*/

const EtUpdateSessionReferenceContent = ({
    id,
    setActiveAdminView,
}) => {

    useTitle(
        "Update Session Reference Content"
    )


    /*
    |--------------------------------------------------------------------------
    | 02 - Fetch Content
    |--------------------------------------------------------------------------
    */

    const {
        data: referenceContent,
        isLoading,
        isFetching,
        isError,
        error,
    } = useGetSessionReferenceContentByIdQuery(
        id,
        {
            skip: !id,
        }
    )


    /*
    |--------------------------------------------------------------------------
    | 03 - Loading / Error
    |--------------------------------------------------------------------------
    */

    if (
        isLoading ||
        isFetching
    ) {

        return (
            <PulseLoader color="#ea580c" />
        )

    }

    if (isError) {

        return (

            <p className="text-sm text-orange-700 p-3">
                {error?.data?.message ||
                    "Unable to fetch Session Reference Content."}
            </p>

        )

    }

    if (!referenceContent) {

        return (

            <p className="text-sm text-gray-600 p-3">
                Session Reference Content not found.
            </p>

        )

    }


    /*
    |--------------------------------------------------------------------------
    | 04 - Render Form
    |--------------------------------------------------------------------------
    */

    return (

        <EtUpdateSessionReferenceContentForm
            key={id}
            id={id}
            referenceContent={referenceContent}
            setActiveAdminView={setActiveAdminView}
        />

    )

}


/*
|--------------------------------------------------------------------------
| 05 - Update Form Wrapper
|--------------------------------------------------------------------------
*/

const EtUpdateSessionReferenceContentForm = ({
    id,
    referenceContent,
    setActiveAdminView,
}) => {

    const navigate = useNavigate()


    /*
    |--------------------------------------------------------------------------
    | 06 - Update Mutation
    |--------------------------------------------------------------------------
    */

    const [
        updateSessionReferenceContent,
        {
            isLoading,
        },
    ] = useUpdateSessionReferenceContentMutation()


    /*
    |--------------------------------------------------------------------------
    | 07 - Return To List
    |--------------------------------------------------------------------------
    */

    const returnToList = () => {

        if (setActiveAdminView) {

            setActiveAdminView(
                "sessionReferenceContent"
            )

        } else {

            navigate(
                "/sessionReferenceContent"
            )

        }

    }


    /*
    |--------------------------------------------------------------------------
    | 08 - Update Content
    |--------------------------------------------------------------------------
    */

    const handleSave = async payload => {

        const response =
            await updateSessionReferenceContent({

                id,

                ...payload,

            }).unwrap()

        alert(
            response?.message ||
            "Session Reference Content updated successfully"
        )

        returnToList()

    }


    /*
    |--------------------------------------------------------------------------
    | 09 - Render
    |--------------------------------------------------------------------------
    */

    return (

        <EtSessionReferenceContentForm
            initialContent={referenceContent}
            formTitle="Update Session Reference Content"
            submitLabel="Update"
            isSaving={isLoading}
            onSave={handleSave}
            onCancel={returnToList}
        />

    )

}


export default EtUpdateSessionReferenceContent